﻿module PortalLibs.Shared.List

let apply fs x = List.map (fun f -> f x) fs

let replace f sub xs =
  let rec finish acc =
    function
    | [] -> acc
    | x :: xs -> finish (x :: acc) xs

  let rec search acc =
    function
    | [] -> None
    | x :: xs ->
      if f x then
        Some(finish ((sub x) :: xs) acc)
      else
        search (x :: acc) xs

  search [] xs

let truncateOpt limitOpt =
  match limitOpt with
  | Some count -> List.truncate count
  | None -> id

let optionMap map list =
  if List.contains None list then
    None
  else
    list |> List.choose id |> List.map map |> Some

let remove itemToRemove list =
  List.filter (fun item -> item <> itemToRemove) list

let addIfNotExists item list =
  if List.contains item list then list else item :: list

let appendIfNotExists item list =
  if List.contains item list then
    list
  else
    List.append list [ item ]
  
let sortOptionsBy noneAtTheEnd select list =
  list |> List.sortWith(fun a b ->
    match (select a, select b) with
    | Some v, Some v2 -> compare v v2
    | Some _, None -> if noneAtTheEnd then -1 else 1
    | None, Some _ -> if noneAtTheEnd then 1 else -1
    | None, None -> 0)